import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Badge } from '@/components/ui/badge'
import { Item, ItemActions, ItemContent, ItemTitle } from '@/components/ui/item'
import type { LinkedRrmSummary } from './buildEhsrOverviewModel'

type LinkedRrmsListProps = {
  measures: LinkedRrmSummary[]
}

export function LinkedRrmsList({ measures }: LinkedRrmsListProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  if (measures.length === 0) {
    return null
  }

  return (
    <ul className='space-y-1'>
      {measures.map((measure) => (
        <li key={measure.id}>
          <Item
            variant='outline'
            size='sm'
            className='hover:bg-accent hover:text-accent-foreground'
            render={
              <Link
                relative='route'
                to={`../risk-reduction-measures/${measure.id}`}
              />
            }
          >
            <ItemContent>
              <ItemTitle className='flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1'>
                <span className='inline-flex min-w-0 items-center gap-1.5'>
                  <span className='truncate'>{measure.name}</span>
                  <Badge
                    variant='outline'
                    className='shrink-0 border-primary/30 bg-primary/10 font-normal text-primary'
                  >
                    {t('ehsrsOverviewPage.badgeRrms')}
                  </Badge>
                  <Badge variant='outline' className='shrink-0 font-normal'>
                    {t(
                      `riskReductionMeasuresLibraryPage.form.measureTypes.${measure.type}`
                    )}
                  </Badge>
                </span>
              </ItemTitle>
            </ItemContent>
            <ItemActions>
              <span className='text-sm font-medium text-muted-foreground'>
                {t('ehsrsOverviewPage.view')}
              </span>
            </ItemActions>
          </Item>
        </li>
      ))}
    </ul>
  )
}
